import React, {useRef} from 'react';
import { useSelectionContainer, SelectionBox } from "react-drag-to-select";
import {IProps} from './types';

const MouseSelection:React.FC<IProps> = ({onSelectionChange, onSelectionStart, onSelectionEnd}) => {
  const selection = useRef({} as SelectionBox);

  const { DragSelection } = useSelectionContainer({
    onSelectionChange: (box) => {
      selection.current = box;
      onSelectionChange(box);
    },
    onSelectionStart: () => {
      onSelectionStart();
    },
    onSelectionEnd: () => {
      if (selection.current?.height >= 5) {
        onSelectionEnd(selection.current);
        selection.current = {} as SelectionBox;
      }
    },
    selectionProps: {
      style: {
        border: '2px dashed #122442',
        borderRadius: 4,
        backgroundColor: '#f66000',
        opacity: 0.5,
      },
    },
  });

  return <DragSelection />;
}

export default MouseSelection;